export class CmdToolsetAuthorization {
    toolsetName:string;
    type:string;
    numberAllowed:number = 0;
    authorized:boolean = false;
    numberExisting:number = 0;
}
